import { posApiRequest } from './posApi';
import type { ShopModules } from '../config/moduleAccess';

/**
 * Which modules does this shop have right now?
 *
 *   GET /shop/entitlements/{shopId}
 *   → { shopId, trial, modules: { cloud_pos: { state, until }, … }, checkedAt }
 *
 * Built from the same TrialTable and BillingDetailsTable rows this dashboard
 * already bills from, so nothing new has to be kept in step. The tablet app
 * asks the same endpoint.
 *
 * Returns null when the answer cannot be fetched — the caller treats that as
 * "unknown", not as "no access".
 */
const EntitlementRepository = {
  async fetchModules(shopId: string): Promise<ShopModules> {
    if (!shopId) return null;
    try {
      const body = await posApiRequest(`/shop/entitlements/${encodeURIComponent(shopId)}`);
      return body?.modules && typeof body.modules === 'object' ? body.modules : null;
    } catch (error) {
      console.warn('[EntitlementRepository] could not fetch modules', error);
      return null;
    }
  },
};

export default EntitlementRepository;
